// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8297) return "static/chunks/8297.38169e59e4dfc4a8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1929":"0f61333a3f0fb460","1985":"bad88bc2d76fecdc","3800":"fffedaab57d814d7","3856":"95ba5845fa6dc2a2","4550":"cdce6d99682a07ef","6462":"bed32894cbe0be84","6567":"2a9a7c124276624a","6877":"680a0915acfdfacb","7761":"8a27216f2dd8a2a7","7909":"be61ef5b730e2a33","9974":"c5b6c1310178602d"}[chunkId] + ".js";
};